import { CallQueueReportState } from "../interfaces/callQueueReport"
import { Types } from "../types"
import { CallQueueReportActions } from "../types/callQueueReport/actionType"




const initialState: CallQueueReportState = {
    getCallQueueReportPending: false,
    getCallQueueReportSuccess: false,
    getCallQueueReportError: '',
    data: {},


    getCallQueueReportByRecordNamePending: false,
    getCallQueueReportByRecordNameSuccess: false,
    getCallQueueReportByRecordNameError: '',
    subData: {},
    reportActivityCallQueue: {
        activeCallQueueCount: 0,
        inCallActiveCallQueueCount: 0,
        customerMemberActiveCallQueueCount: 0,
        customerMembersInfoModels: []
    },
    reportCallQueue: {
        data: [],
        totalCount: 0,
        pageNumber: 0,
        pageSize: 0
    },
    weeklyReportCallQueue: []
}


const callQueueReportReducer = (state = initialState, action: CallQueueReportActions) => {
    switch (action.type) {

        case Types.GET_CALL_QUEUE_REPORT_REQUEST:
            return {
                ...state,
                getCallQueueReportPending: true,
                getCallQueueReportSuccess: false,
                getCallQueueReportError: '',
                data: {}
            }

        case Types.GET_CALL_QUEUE_REPORT_SUCCESS:
            return {
                ...state,
                getCallQueueReportPending: false,
                getCallQueueReportSuccess: true,
                getCallQueueReportError: '',
                data: action.payload.params
            }
        case Types.GET_CALL_QUEUE_REPORT_ERROR:
            return {
                ...state,
                getCallQueueReportPending: false,
                getCallQueueReportSuccess: false,
                getCallQueueReportError: action.payload,
                data: {}
            }


        case Types.GET_CALL_QUEUE_BY_RECORD_NAME_REQUEST:
            return {
                ...state,
                getCallQueueReportByRecordNamePending: true,
                getCallQueueReportByRecordNameSuccess: false,
                getCallQueueReportByRecordNameError: '',
                subData: {}
            }

        case Types.GET_CALL_QUEUE_BY_RECORD_NAME_SUCCESS:
            return {
                ...state,
                getCallQueueReportByRecordNamePending: false,
                getCallQueueReportByRecordNameSuccess: true,
                getCallQueueReportByRecordNameError: '',
                subData: action.payload.params
            }
        case Types.GET_CALL_QUEUE_BY_RECORD_NAME_ERROR:
            return {
                ...state,
                getCallQueueReportByRecordNamePending: false,
                getCallQueueReportByRecordNameSuccess: false,
                getCallQueueReportByRecordNameError: action.payload,
                subData: {}
            }

        case Types.GET_REPORT_CALL_QUEUE_BY_DATE_REQUEST:
            return {
                ...state,
                getReportCallQueuePending: true,
                getReportCallQueueSuccess: false,
                getReportCallQueueError: '',
                reportCallQueue: { data: [] }
            }

        case Types.GET_REPORT_CALL_QUEUE_BY_DATE_SUCCESS:
            return {
                ...state,
                getReportCallQueuePending: false,
                getReportCallQueueSuccess: true,
                reportCallQueue: action.payload
            }
        case Types.GET_REPORT_CALL_QUEUE_BY_DATE_ERROR:
            return {
                ...state,
                getReportCallQueuePending: false,
                getReportCallQueueError: action.payload,
            }

        ///--
        case Types.GET_REPORT_ACTIVITY_CALL_QUEUE_REQUEST:
            return {
                ...state,
                getReportActivityCallQueuePending: true,
                getReportActivityCallQueueSuccess: false,
                getReportActivityCallQueueError: '',
                reportActivityCallQueue: {}
            }

        case Types.GET_REPORT_ACTIVITY_CALL_QUEUE_SUCCESS:
            return {
                ...state,
                getReportActivityCallQueuePending: false,
                getReportActivityCallQueueSuccess: true,
                reportActivityCallQueue: action.payload.params
            }
        case Types.GET_REPORT_ACTIVITY_CALL_QUEUE_ERROR:
            return {
                ...state,
                getReportActivityCallQueuePending: false,
                getReportActivityCallQueueError: action.payload,
            }


        ///--
        case Types.GET_WEEKLY_REPORT_CALL_QUEUE_REQUEST:
            return {
                ...state,
                getWeeklyReportCallQueuePending: true,
                getWeeklyReportCallQueueSuccess: false,
                getWeeklyReportCallQueueError: '',
                WeeklyReportCallQueue: []
            }

        case Types.GET_WEEKLY_REPORT_CALL_QUEUE_SUCCESS:
            return {
                ...state,
                getWeeklyReportCallQueuePending: false,
                getWeeklyReportCallQueueSuccess: true,
                weeklyReportCallQueue: action.payload.params
            }
        case Types.GET_WEEKLY_REPORT_CALL_QUEUE_ERROR:
            return {
                ...state,
                getWeeklyReportCallQueuePending: false,
                getWeeklyReportCallQueueError: action.payload,
            }



        //***************************** */
        default:
            return {
                ...state,
            }
    }
}

export default callQueueReportReducer